import Golf6 from "../images/cars-big/golf6.jpg";
import AudiA1 from "../images/cars-big/audia1.jpg";
import Toyota from "../images/cars-big/toyotacamry.jpg";
import Bmw320 from "../images/cars-big/bmw320.jpg";
import Benz from "../images/cars-big/benz.jpg";
import Passat from "../images/cars-big/passatcc.jpg";

export const CAR_DATA = [
  [
    {
      name: "Toyota Rumion",
      details: "The Toyota Rumion is a 7-seater Multi-Purpose Vehicle (MPV) that is a rebadged version of the Maruti Suzuki Ertiga.",
      price: "37",
      img: Golf6,
    },
  ],
  [
    {
      name: "Innova Crysta",
      details: "The Toyota Innova Crysta is a 7-seater highly regarded Multi-Purpose Vehicle (MPV) known for its reliability, spacious and comfortable interiors, and robust build quality.",
      price: "45",
      img: AudiA1,
    },
  ],
  [
    {
      name: "Maruti Suzuki Ertiga",
      details: "The Maruti Suzuki Ertiga is a popular 7-seater Multi-Purpose Vehicle (MPV) that is known for its practicality, fuel efficiency, and competitive price.",
      price: "30",
      img: Toyota,
    },
  ],
  [
    {
      name: "Maruti Suzuki Dzire",
      details: "The Maruti Suzuki Dzire is a 5-seater compact sedan, renowned for its excellent fuel efficiency, spacious interior, and affordability.",
      price: "35",
      img: Bmw320,
    },
  ],
  [
    {
      name: "Hyundai Aura",
      details: "The Hyundai Aura is a 5-seater subcompact sedan that stands out for its blend of features, fuel efficiency, and comfortable ride quality.",
      price: "50",
      img: Benz,
    },
  ],
  [
    {
      name: "Maruti Suzuki Wagon R",
      details: "The Maruti Suzuki Wagon R is a popular 5-seater hatchback known for its 'tall-boy' design, which offers excellent cabin space and practicality.",
      price: "25",
      img: Passat,
    },
  ],
];
